import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { PaginationComponent } from '../pagination/pagination.component';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'dr-ops-stream-ui-table-state',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [EmptyStateComponent, PaginationComponent],
  templateUrl: './table-state.component.html',
  styleUrls: ['./table-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableStateComponent {
  isLoading = input.required<boolean>();
  hasData = input.required<boolean>();
  totalItems = input.required<number>();
  emptyTitle = input<string>('No items found.');
}
